import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(LocalizedFormat);
dayjs.extend(utc);

export default dayjs;
